import { render, staticRenderFns } from "./expertColumn.vue?vue&type=template&id=3b05a394&scoped=true&"
import script from "./expertColumn.vue?vue&type=script&lang=js&"
export * from "./expertColumn.vue?vue&type=script&lang=js&"
import style0 from "./expertColumn.vue?vue&type=style&index=0&id=3b05a394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05a394",
  null
  
)

export default component.exports